'use client';
import Link from 'next/link';

function LinkIcon({
    fill,
    iconSize,
    mobileIconSize,
}: Readonly<{ fill: string; iconSize: number; mobileIconSize: number }>) {
    return (
        <svg
            className="inline-block align-middle sm:h-[var(--sm-height)] sm:w-[var(--sm-width)]"
            style={{
                width: mobileIconSize,
                height: mobileIconSize,
                ...(iconSize
                    ? ({
                          '--sm-width': `${iconSize}px`,
                          '--sm-height': `${iconSize}px`,
                      } as React.CSSProperties)
                    : {}),
            }}
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill}
        >
            <path d="M235.093333 215.466667v85.333333h427.946667l-477.866667 477.866667 60.16 60.16 477.866667-477.866667v427.946667h85.333333V215.466667z"></path>
        </svg>
    );
}

export default function CustomLink({
    children,
    href,
    fill,
    iconSize,
    mobileIconSize,
}: Readonly<{
    children: React.ReactNode;
    href: string;
    fill?: string;
    iconSize?: number;
    mobileIconSize?: number;
}>) {
    const fillColor = !fill ? '#000000' : fill;
    const size = iconSize ?? 18;
    const mobileSize = mobileIconSize ?? 16;

    return (
        <Link href={href} prefetch target="_blank">
            <span className={`border-b`} style={{ borderColor: fillColor }}>
                {children}
                <LinkIcon
                    fill={fillColor}
                    iconSize={size}
                    mobileIconSize={mobileSize}
                />
            </span>
        </Link>
    );
}
